var _rect, _rect2, _rect3, _line, _rect4, _line2, _rect5, _line3, _rect6, _line4, _rect7, _line5, _rect8, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchoolRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.16669,
    y: 1,
    width: 5.5,
    height: 22,
    rx: 1,
    fill: "#6E6B7B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0833,
    y: 1,
    width: 5.5,
    height: 22,
    rx: 1,
    fill: "#6E6B7B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.68353,
    y: 5.95068,
    width: 2.75,
    height: 2.75,
    rx: 1,
    transform: "rotate(-90 2.68353 5.95068)",
    fill: "#6E6B7B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 5.45044,
    x2: 2,
    y2: 3.70044,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6001,
    y: 5.95093,
    width: 2.75,
    height: 2.75,
    rx: 1,
    transform: "rotate(-90 14.6001 5.95093)",
    fill: "#6E6B7B"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.9167,
    y1: 5.45068,
    x2: 13.9167,
    y2: 3.70068,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2.68353,
    y: 12.916,
    width: 2.75,
    height: 2.75,
    rx: 1,
    transform: "rotate(-90 2.68353 12.916)",
    fill: "#6E6B7B"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 12.416,
    x2: 2,
    y2: 10.666,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6001,
    y: 12.916,
    width: 2.75,
    height: 2.75,
    rx: 1,
    transform: "rotate(-90 14.6001 12.916)",
    fill: "#6E6B7B"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 13.9166,
    y1: 12.416,
    x2: 13.9166,
    y2: 10.666,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2.68353,
    y: 20.25,
    width: 2.75,
    height: 2.75,
    rx: 1,
    transform: "rotate(-90 2.68353 20.25)",
    fill: "#6E6B7B"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 19.75,
    x2: 2,
    y2: 18,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6001,
    y: 20.25,
    width: 2.75,
    height: 2.75,
    rx: 1,
    transform: "rotate(-90 14.6001 20.25)",
    fill: "#6E6B7B"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 13.9167,
    y1: 19.75,
    x2: 13.9167,
    y2: 18,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolRoom);
export default __webpack_public_path__ + "static/media/school-room.097057ac95f3bbff31f47a11dde31288.svg";
export { ForwardRef as ReactComponent };